import React from 'react';
import {createRoot} from 'react-dom/client';

import App from './App';
import './index.css';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  // 严格模式会导致渲染2次（仅在开发模式下运行，不会影响生产构建）
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
